export default __webpack_public_path__ + "0cccf74585e37e53c65ed96942ee2a88.svg";